import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import { store } from "../store";

const getDefaultSelectedStation = () => {
  return {
    responsableStaff: {},
    hardwares: [],
    phones: [],
    physicalProperties: [],
    workingDays: [
      { start: "", end: "" },
      { start: "", end: "" },
      { start: "", end: "" },
      { start: "", end: "" },
      { start: "", end: "" },
      { start: "", end: "" },
      { start: "", end: "" },
    ],
    stationPlatforms: [],
    stationStatus: {},
    salesChannels: [{ salesChannel: "" }],
    stationType: {},
    unit: { deskCode: null, parentUnitId: null, ipAddress: null, penName: null, name: null },
    active: false,
    orangeDeskEmail: null,
  };
};
let sessionId = window.name;
export default {
  state: () => ({
    selectedStation: getDefaultSelectedStation(),
    cities: [],
    stationStatuses: [],
    districts: [],
    neighbourhoods: [],
    staff: [],
    publishedStations: [],
  }),

  mutations: {
    setSelectedStationFromKKYS(state, selectedKKYStation) {
      let station = {
        name: selectedKKYStation.istasyonAdi,
        technicalUnit: selectedKKYStation.istasyonKodu,
        latitude: Number(selectedKKYStation.enlem),
        longitude: Number(selectedKKYStation.boylam),
        altitude: Number(selectedKKYStation.rakim),
        startKm: Math.round(selectedKKYStation.baslangicms / 100) / 10,
        endKm: Math.round(selectedKKYStation.bitisms / 100) / 10,
        cityId: Number(selectedKKYStation.bolge[0] === "0" ? selectedKKYStation.bolge.slice(1) : selectedKKYStation.bolge),
        districtId: null,
        neighbourhoodId: null,
        address: selectedKKYStation.adres,
        areaCode: Number(selectedKKYStation.bolge[0] === "0" ? selectedKKYStation.bolge.slice(1) : selectedKKYStation.bolge),
        responsableStaff: {},
        hardwares: [],
        phones: [],
        physicalProperties: [],
        workingDays: [
          { start: "", end: "" },
          { start: "", end: "" },
          { start: "", end: "" },
          { start: "", end: "" },
          { start: "", end: "" },
          { start: "", end: "" },
          { start: "", end: "" },
        ],
        stationPlatforms: [],
        stationStatus: {},
        stationType: {},
        unit: { deskCode: null, parentUnitId: null, ipAddress: null, penName: null, name: null },
        email: selectedKKYStation.eposta,
        stationNumber: selectedKKYStation.istasyonNo,
        // id:selectedKKYStation.id,
        salesChannels: [{ salesChannel: "" }],
      };
      if (selectedKKYStation.id !== undefined) {
        station.id = selectedKKYStation.id;
        station.unitId = selectedKKYStation.unitId;
        station.districtId = selectedKKYStation.districtId;
        station.neighbourhoodId = selectedKKYStation.neighbourhoodId;
        station.hardwares = selectedKKYStation.hardwares;
        station.phones = selectedKKYStation.phones;
        station.physicalProperties = selectedKKYStation.physicalProperties;
        station.workingDays = selectedKKYStation.workingDays;
        station.stationPlatforms = selectedKKYStation.stationPlatforms;
        station.stationStatus = selectedKKYStation.stationStatus;
        station.stationType = selectedKKYStation.stationType;
        station.unit = selectedKKYStation.unit;
        station.salesChannels = selectedKKYStation.salesChannels;
        station.IATACode = selectedKKYStation.IATACode;
        station.active = selectedKKYStation.active;
        station.detail = selectedKKYStation.detail;
        station.passengerDrop = selectedKKYStation.passengerDrop;
        station.uicCode = selectedKKYStation.uicCode;
        station.disabledAccessibility = selectedKKYStation.disabledAccessibility;
        station.showOnQuery = selectedKKYStation.showOnQuery;
      }
      Vue.set(state, "selectedStation", station);
    },
    setSelectedStation(state, selectedStation) {
      Vue.set(state, "selectedStation", selectedStation);
    },
    setCities(state, cities) {
      // [SEHIR-SAAT-DILIMI-KAPALI] Seferler her istasyonda ORER'deki saatle (Europe/Istanbul) gösterilir;
      // şehrin kendi saat dilimi (Europe/Sofia, Europe/Bucharest, Asia/Tehran) kullanılmaz.
      // Ekranlardaki şehir saat dilimi mantığı yerinde duruyor; geri açmak için aşağıdaki if bloğunu kaldırmak yeterli.
      // Action'lar response.data'yı döndürdüğü için atama yerinde (in-place) yapılıyor, citiesMap kuran ekranlar da etkilenir.
      if (Array.isArray(cities)) {
        cities.forEach((city) => {
          if (city) city.timezone = "Europe/Istanbul";
        });
      }
      Vue.set(state, "cities", cities);
    },
    setDistricts(state, districts) {
      Vue.set(state, "districts", districts);
    },
    setNeighbourhoods(state, neighbourhoods) {
      Vue.set(state, "neighbourhoods", neighbourhoods);
    },
    setStaff(state, staff) {
      Vue.set(state, "staff", staff);
    },
    setDefaultSelectedStation(state) {
      Vue.set(state, "selectedStation", getDefaultSelectedStation());
    },
  },

  actions: {
    //TODO: load, create, update, delete
    loadStations: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/stations/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadStationWithPairs: (context) => {
      return axios
        .get(context.getters.getTmsCdnServiceUrl + "/station-pairs-GISE.json")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPublishedStations: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/entity/published").then((response) => {
        return response.data;
      });
    },

    // paire bakmaksızın bütün istasyonları veriyor
    loadAllStations: (context) => {
      return axios
        .get(context.getters.getTmsCdnServiceUrl + "/stations.json")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadStaff: (context) => {
      //http://dev-rail.ditravo.com:8700/staffs/entity?environment=dev
      return axios.get(context.getters.getMcServiceUrl + "/staffs/entity").then((response) => {
        context.commit("setStaff", response.data);
      });
    },

    createStation: (context, station) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/stations/entity", station)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadStation: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/entity/" + request.id).then((response) => {
        context.commit("setSelectedStation", response.data);
        return response.data;
      });
    },

    loadNeighbourhoods: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/neighbourhoods/" + request.id).then((response) => {
        context.commit("setNeighbourhoods", response.data);
        return response.data;
      });
    },

    loadPublishedNeighbourhoods: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/neighbourhoods/entity/published").then((response) => {
        context.commit("setNeighbourhoods", response.data);
        return response.data;
      });
    },

    loadDistricts: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/cities/" + request.id + "/districts").then((response) => {
        context.commit("setDistricts", response.data);
        return response.data;
      });
    },

    loadCities: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/cities/entity").then((response) => {
        context.commit("setCities", response.data);
        return response.data;
      });
    },
    loadPublishedCities: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/cities/entity/published").then((response) => {
        context.commit("setCities", response.data);
        return response.data;
      });
    },
    loadPublishedCitiesFromTmsCdn: (context, request) => {
      return axios.get(context.getters.getTmsCdnServiceUrl + "/cities.json").then((response) => {
        context.commit("setCities", response.data);
        return response.data;
      });
    },

    loadStationHistory: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/location/stations/history/search", request).then((response) => {
        return response.data;
      });
    },

    loadSelectedStationHistory: (context, station) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/history/" + station.id).then((response) => {
        return response.data;
      });
    },

    loadStationPhysicalProperties: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/physical-properties/entity").then((response) => {
        return response.data;
      });
    },

    loadStationHardwares: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/hardwares/entity").then((response) => {
        context.commit("station");
        return response.data;
      });
    },

    loadStationStationTypes: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-types/entity").then((response) => {
        context.commit("setStationTypes", response.data);
        return response.data;
      });
    },
    loadStationStationStatuses: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/station-status/entity")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadPublishedStationStatuses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/station-status/entity/published").then((response) => {
        context.commit("setStationStatuses", response.data);
        return response.data;
      });
    },
    deleteStation: (context, station) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/stations/entity/" + station.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          station.intents = intents;
          station.intentId = response.data.id;
          return station;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftStation: (context, station) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/stations/draft/" + station.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishStation: (context, station) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/publish/" + station.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectStation: (context, station) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/reject/" + station.intentId).then((response) => {
        helper.recallOrRejectEntity(station, "station");
        return response.data;
      });
    },

    sendToApprovalStation: (context, station) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/sendToApproval/" + station.intentId).then((response) => {
        if (station.intents[0].type === "CREATE_STATION") {
          station.intents[0].status = "WAITING_APPROVAL";
        } else if (station.intents[0].type === "UPDATE_STATION") {
          station.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    loadStaffUsers: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/user/live/staffs").then((response) => {
        return response.data;
      });
    },

    loadPublishedStaff: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/staffs/entity/published").then((response) => {
        context.commit("setStaff", response.data);
        return response.data;
      });
    },

    loadStaffUser: (context, request) => {
      return axios
        .get(
          context.getters.getMcServiceUrl +
            "/user/live/staffs/search?name=" +
            request.name +
            "&surname=" +
            request.surname +
            "&registrationId=" +
            request.registrationId
        )
        .then((response) => {
          return response.data;
        });
    },

    recallStation: (context, station) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/recall/" + station.intentId).then((response) => {
        helper.recallOrRejectEntity(station, "station");
        return response.data;
      });
    },
    cancelStation: (context, station) => {
      return axios.get(context.getters.getMcServiceUrl + "/stations/cancel/" + station.intentId).then((response) => {
        return response.data;
      });
    },

    loadTrainCars: (context, request) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/train/get-train-cars/" + request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadTrain: (context, request) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/train/get-train/" + request.id)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadLineStations: (context, lineId) => {
      return axios.get(context.getters.getTmsServiceUrl + "/inventory/load-line-stations-by-line-id/" + lineId).then((response) => {
        return response.data;
      });
    },

    loadStationsByLineId: (context, lineId) => {
      return (
        axios
          .get(context.getters.getMcServiceUrl + "/lines/" + lineId + "/stations")
          // return axios.get(context.getters.getMcServiceUrl+'/lines/' +3+ '/stations') // TODO: lineId
          .then((response) => {
            return response.data;
          })
          .catch((err) => {
            return err.response;
          })
      );
    },
    loadKKYStations: (context) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/stations/kky")
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadKKYStationByStationNo: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/stations/kky/" + request.stationNo)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getStationByUnitId: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/stations/get-by-unit/" + request.id)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadMutualTrainStations: (context, request) => {
      return axios
        .post(context.getters.getTmsServiceUrl + "/inventory/get-mutual-train-stations", request)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },

  getters: {
    getSelectedStation: (state) => {
      return state.selectedStation;
    },
    getCities: (state) => {
      return state.cities;
    },
    getDistricts: (state) => {
      return state.districts;
    },
    getNeighbourhoods: (state) => {
      return state.neighbourhoods;
    },
    getStaff: (state) => {
      return state.staff;
    },
  },
};
